import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {CSVLink} from 'react-csv'
import {Page, Text, View, Document, StyleSheet, PDFDownloadLink} from '@react-pdf/renderer'
import {Dropdown} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import WithdrawList from './WithdrawList'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}


const Withdraws = () => {

    const apiToken = getLocalData().api_token

    const [dateRange, setDateRange] = useState([null, null])
    const [startDate, endDate] = dateRange
    const [WithdrawDatas, setWithdrawDatas] = useState([])
    const [loading, setLoading] = useState(false)

    const [showWithdrawDetailModal, setShowWithdrawDetailModal] = useState(false)
    const [withdrawId, setWithdrawId] = useState()

    const API_URL = process.env.REACT_APP_API_URL
    const GET_WITHDRAW_DATA = `${API_URL}/user/withdraws-export`

    const getWithdraws = async (startDate,endDate) => {
       setLoading(true)
    const config = {
      headers: {Authorization: `Bearer ${apiToken}`},
      params:{
        start_date : startDate,
        end_date : endDate
      }
    }
    await axios
      .get(GET_WITHDRAW_DATA, config)
      .then((response) => {
        setWithdrawDatas(response.data.data)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }

  useEffect(() => {
      getWithdraws(startDate,endDate)
    }, [])

    const Pdfstyles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      padding: 20,
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableCol: {
      width: '25%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCell: {
      margin: 'auto',
      marginTop: 5,
      marginBottom: 5,
      fontSize: 10,
    },
    header: {
      fontSize: 18,
      marginBottom: 10,
      textAlign: 'center',
    },
  })

    const statusCondition = (val) => {
    var statusText = ''
    if (val == 0) {
      statusText = 'Approved'
    } else if (val == 1) {
      statusText = 'Pending'
    } else if (val == 2) {
      statusText = 'Rejected'
    }
    return statusText
  }

  const withdrawCsvHeaders = [
    {label: 'Payment No', key: 'withdraw_no'},
    // {label: 'User', key: 'user'},
    {label: 'Amount', key: 'amount'},
    {label: 'Payment Date', key: 'date'},
    {label: 'Payment', key: 'payment_status'},

  ]

  const withdrawCsvData = WithdrawDatas.map((item) => ({
    withdraw_no : item.withdraw_no,
    // user: item.user_name,
    amount: '$' + item.payment,
    date: new Date(item.date).toLocaleDateString(),
    payment_status: statusCondition(item.status),
  }))
  
  const WithdrawPdfDocument = ({data}) => (
    <Document>
      <Page size='A4' orientation='portrait' style={Pdfstyles.page}>
        {/* <Text style={Pdfstyles.header}>Statement Data</Text> */}
        <View style={Pdfstyles.table}>
          {/* Table Header */}
          <View style={Pdfstyles.tableRow}>
            {withdrawCsvHeaders.map((header, index) => (
              <View style={[Pdfstyles.tableCol, {backgroundColor: 'skyblue'}]} key={index}>
                <Text style={Pdfstyles.tableCell}>{header.label}</Text>
              </View>
            ))}
          </View>
          {/* Table Content */}
          {data.map((item, index) => (
            <View style={Pdfstyles.tableRow} key={index}>
              {withdrawCsvHeaders.map((header, headerIndex) => (
                <View style={Pdfstyles.tableCol} key={headerIndex}>
                  <Text style={Pdfstyles.tableCell}>{item[header.key]}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  )


  const currentDate = new Date()
  const formattedDate = currentDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })

  

  


  return (
      <div className='card card-body shadow top-rounded'>
              <div className='card-title d-flex justify-content-between align-items-center'>
                <div className='d-flex align-items-center'>
                  <h3 className='m-0 text-gray-800'>Withdraws</h3>
                </div>

                <div className='d-flex align-items-center'>
                  
                    <Dropdown>
                      <Dropdown.Toggle variant='success' id='dropdown-basic' className='btn btn-primary btn-sm'>
                        Export
                      </Dropdown.Toggle>

                      <Dropdown.Menu style={{width:'225px'}}>
                        <Dropdown.Item onClick={(e)=>{
                          e.preventDefault();
                          e.stopPropagation();
                        }}>
                          <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            onChange={(update) => {
                              setDateRange(update)
                              const [start, end] = update;
                              getWithdraws(start,end);
                            }}
                            isClearable={true}
                            className='form-control form-control-sm'
                            placeholderText='Select Date Range'
                          />
                        </Dropdown.Item>
                        <Dropdown.Item as="div" >
                          <div className="d-flex justify-content-between align-items-center">
                          <button className='btn btn-sm btn-primary text-dark'>
                            <CSVLink
                              className='downloadbtn'
                              filename={`withdraws_${formattedDate}.csv`}
                              headers={withdrawCsvHeaders}
                              data={withdrawCsvData}
                              style={{color: '#fff'}}
                            >
                              {loading ? 'Loading' : 'Export CSV'}
                            </CSVLink>
                          </button>
                          <PDFDownloadLink
                            document={<WithdrawPdfDocument data={withdrawCsvData} />}
                            fileName={`withdraws_${formattedDate}.pdf`}
                            className='btn btn-sm btn-danger ms-2'
                          >
                            {({blob, url, loading, error}) =>
                              loading ? 'Loading' : 'Export PDF'
                            }
                          </PDFDownloadLink>
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                </div>
              </div>
              <WithdrawList/>
            </div>
  )
}

export default Withdraws